// Shared between the single flow export dialog and the bulk export dialog.

import http from './http';

export const exportFlows = (flowIds, includeSubflows) => http
    .post('/flows/export', { flow_ids: flowIds, include_subflows: includeSubflows })
    .then((res) => res.data);

export const notFoundMessage = (notFound) => `Subflows not included: ${notFound.map((item) => item.reference ?? item.method).join(', ')}`;

export function convertFileName(input) {
    let result = input.toLowerCase();
    result = result.replace(/\s+/g, '_');
    result = result + '.json';
    return result;
}

export function simplifyJson(jsonStr) {
    try {
        const data = JSON.parse(jsonStr);

        if (Array.isArray(data)) {
            return JSON.stringify(data.map((item) => JSON.parse(simplifyJson(JSON.stringify(item)))));
        }

        delete data.user_id;
        delete data.id;
        delete data.lbh_status;

        if (data.methods && Array.isArray(data.methods)) {
            data.methods.forEach(method => {
                delete method.flowMethodId;
                delete method.type;
                delete method.sensitive;

                if (method.integration === 'Infintegration' || method.name === 'Input Port') {
                    delete method.integration;
                    delete method.method;
                }

                if (method.name === 'Input Port') {
                    delete method.url;
                }

                if (method.fields && typeof method.fields === 'object') {
                    Object.values(method.fields).forEach(field => {
                        delete field.in;
                        delete field.sensitive;

                        if (field.source && Array.isArray(field.source)) {
                            field.source.forEach(src => {
                                if (src.source && typeof src.source === 'object') {
                                    delete src.source.in;
                                    delete src.source.sensitive;
                                }

                                if (src.conditions && Array.isArray(src.conditions)) {
                                    src.conditions.forEach(condition => {
                                        if (condition.operand_a && typeof condition.operand_a === 'object') {
                                            delete condition.operand_a.in;
                                            delete condition.operand_a.sensitive;
                                        }
                                        if (condition.operand_b && typeof condition.operand_b === 'object') {
                                            delete condition.operand_b.in;
                                            delete condition.operand_b.sensitive;
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            });
        }

        return JSON.stringify(data);
    } catch {
        return jsonStr;
    }
}